export const formatarDinheiro = (param) => {    
    //console.log(param)
    return (param).toLocaleString("pt-BR", { style: "currency", currency: "BRL"})    
}

